export const isReceivedDispatchStatus = status => ['received_to_outlet','received_by_stakeholder','received_to_warehouse'].includes(String(status || '').trim().toLowerCase());
